const initialState = {
  users: [],
  educators: [],
  schools: [],
  loading: true,
  userPages: 1,
  schoolPages: 1,
  educatorPages: 1,
  currentPage:1
};

const userReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "SET_USERS": {
      return {
        ...state,
        users: actions.users,
        loading: actions.loading,
        userPages: actions.data.totalPages,
        totalItems:actions.data.totalItems,
        currentPage:actions.data.currentPage,
        ...actions.data,
      };
    }
    case "SET_SCHOOL_USERS": {
      return {
        ...state,
        schools: actions.schoolUsers,
        loading: actions.loading,
        schoolPages:actions.data.totalPages,
        totalItems:actions.data.totalItems,
        ...actions.data,
      };
    }
    case "SET_EDUCATOR_USERS": {
      return {
        ...state,
        educators: actions.educatorUsers,
        loading: actions.loading,
        educatorPages:actions.data.totalPages,
        totalItems:actions.data.totalItems,
        ...actions.data,
      };
    }

    case "RESET_USER_DATA": {
      return { ...state, users: [] };
    }
    case "RESET_SCHOOL_DATA": {
      return { ...state, schools: [] };
    }
    case "RESET_EDUCATOR_DATA": {
      return { ...state, educators: [] };
    }
    case "Loading": {
      return { ...state, loading: true };
    }
    default:
      return state;
  }
};
export default userReducer;
